import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Auto-logout on 401: if the session expired, redirect to login page.
// We DO NOT redirect on /auth/me itself (that's the initial silent probe).
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !url.includes("/auth/me") && !url.includes("/auth/login")) {
      if (typeof window !== "undefined" && !window.location.pathname.startsWith("/giris")) {
        try {
          window.dispatchEvent(new CustomEvent("session-expired"));
        } catch (_) {}
      }
    }
    return Promise.reject(error);
  },
);

export default api;
